<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Tables</h4><span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Basic
    Tables</span>
  </div>
</div>
<div class="d-flex my-xl-auto right-content mr-2">
  <div class="pr-1 mb-3 mb-xl-0">
    <button type="button" class="btn btn-info btn-icon me-2"><i class="mdi mdi-filter-variant"></i></button>
  </div>
  <div class="pr-1 mb-3 mb-xl-0">
    <button type="button" class="btn btn-danger btn-icon me-2"><i class="mdi mdi-star"></i></button>
  </div>
  <div class="pr-1 mb-3 mb-xl-0">
    <button type="button" class="btn btn-warning  btn-icon me-2"><i class="mdi mdi-refresh"></i></button>
  </div>
  <div class="mb-3 mb-xl-0">
    <div ngbDropdown class="btn-group">
      <button type="button" class="btn btn-primary">14 Aug 2019</button>
      <button type="button" ngbDropdownToggle class="btn btn-primary dropdown-toggle-split" id="dropdownMenuDate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownMenuDate" data-x-placement="bottom-end">
        <a ngbDropdownItem href="javascript:;">2015</a>
        <a ngbDropdownItem href="javascript:;">2016</a>
        <a ngbDropdownItem href="javascript:;">2017</a>
        <a ngbDropdownItem href="javascript:;">2018</a>
      </div>
    </div>
  </div>
</div>
</div>
<!-- breadcrumb -->

<!-- row opened -->
<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mg-b-0">SIMPLE TABLE</h4>
          <i class="mdi mdi-dots-horizontal text-gray"></i>
        </div>
        <p class="tx-12 tx-gray-500 mb-2">Example of Valex Simple Table.
        </p>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table mg-b-0 text-md-nowrap">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Position</th>
                <th>Salary</th>
              </tr>
            </thead>
            <tbody>
              @for (table of basicTableData; track table) {
                <tr>
                  <th>{{table.id}}</th>
                  <td>{{table.name}}</td>
                  <td>{{table.position}}</td>
                  <td>{{table.salary | currency:'USD':'symbol':'3.0-0'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!--/div-->

  <!--div-->
  <div class="col-xl-12">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mg-b-0">STRIPED ROWS</h4>
          <i class="mdi mdi-dots-horizontal text-gray"></i>
        </div>
        <p class="tx-12 tx-gray-500 mb-2">Example of Valex Striped Rows..
        </p>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped mg-b-0 text-md-nowrap">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Position</th>
                <th>Salary</th>
              </tr>
            </thead>
            <tbody>
              @for (table of basicTableData; track table) {
                <tr>
                  <th>{{table.id}}</th>
                  <td>{{table.name}}</td>
                  <td>{{table.position}}</td>
                  <td>{{table.salary | currency:'USD':'symbol':'3.0-0'}}</td>
                </tr>
              }

            </tbody>
          </table>
        </div><!-- bd -->
      </div><!-- bd -->
    </div><!-- bd -->
  </div>
  <!--/div-->

  <!--div-->
  <div class="col-xl-12">
    <div class="card mg-b-20">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mg-b-0">Bordered Table</h4>
          <i class="mdi mdi-dots-horizontal text-gray"></i>
        </div>
        <p class="tx-12 tx-gray-500 mb-2">Example of Valex Bordered Table.</p>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered mg-b-0 text-md-nowrap border-bottom">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Position</th>
                <th>Salary</th>
              </tr>
            </thead>
            <tbody>
              @for (table of basicTableData; track table) {
                <tr>
                  <th>{{table.id}}</th>
                  <td>{{table.name}}</td>
                  <td>{{table.position}}</td>
                  <td>{{table.salary | currency:'USD':'symbol':'3.0-0'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!--/div-->

  <!--div-->
  <div class="col-xl-12">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mg-b-0">Hoverable Rows Table</h4>
          <i class="mdi mdi-dots-horizontal text-gray"></i>
        </div>
        <p class="tx-12 tx-gray-500 mb-2">Example of Valex Hoverable Rows Table.</p>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover mb-0 text-md-nowrap table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Position</th>
                <th>Salary</th>
              </tr>
            </thead>
            <tbody>
              @for (table of basicTableData; track table) {
                <tr>
                  <th>{{table.id}}</th>
                  <td>{{table.name}}</td>
                  <td>{{table.position}}</td>
                  <td>{{table.salary | currency:'USD':'symbol':'3.0-0'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!--/div-->
</div>
<!-- /row -->